import type { User, UserRole } from "@/types/user";
import { UserResponseDtoRole } from "@/types/api";
import { SYSTEM_ROLE_LABELS } from "@/features/roles/constants/role-labels";

const ADMIN_ROLES: UserRole[] = [
  UserResponseDtoRole.SUPER_ADMIN,
  UserResponseDtoRole.SUB_ADMIN,
];

export function isAdmin(user: User | null): boolean {
  return !!user?.role && ADMIN_ROLES.includes(user.role);
}

export function isSuperAdmin(user: User | null): boolean {
  return user?.role === UserResponseDtoRole.SUPER_ADMIN;
}

export function isSubAdmin(user: User | null): boolean {
  return user?.role === UserResponseDtoRole.SUB_ADMIN;
}

/**
 * Super Admin and Sub-Admin role tier (nav items, role-gated routes).
 * Department scope for governance APIs uses `governanceDepartmentAccess` from /api/auth/me.
 */
export function isPlatformAdmin(user: User | null): boolean {
  return isSuperAdmin(user) || isSubAdmin(user);
}

export function isEditor(user: User | null): boolean {
  return user?.role === UserResponseDtoRole.EDITOR;
}

export function getRoleDisplayName(
  role: UserRole,
  labelMap?: Record<string, string>,
): string {
  if (labelMap?.[role]) return labelMap[role]!;
  if (SYSTEM_ROLE_LABELS[role]) return SYSTEM_ROLE_LABELS[role]!;
  return role;
}

export function requireAdmin(user: User | null): void {
  if (!isAdmin(user)) {
    throw new Error(
      "غير مصرح لك بالوصول إلى لوحة الإدارة. هذا المحتوى متاح للمدراء فقط.",
    );
  }
}
